import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { useRef } from 'react';
import { Icon } from '@iconify/react';
import cx from 'classnames';
import { Button } from '../Button';
const Input = ({ className = '', onAction, actionIcon = _jsx(Icon, { icon: "ep:arrow-right" }), actionButton, onBlur, ...props }) => {
    const ref = useRef(null);
    const hasAction = onAction != null;
    return (_jsxs("div", { className: "relative", ref: ref, onBlur: e => {
            (async () => {
                if (onBlur == null || ref.current == null) {
                    return;
                }
                await new Promise(resolve => setTimeout(resolve));
                if (ref.current.contains(document.activeElement)) {
                    return;
                }
                onBlur(e);
            })().catch(err => {
                console.error('Error in processing blur event', err);
            });
        }, children: [_jsx("input", { ...props, className: cx('relative rounded-md border border-gray-200 bg-white p-2 dark:border-gray-600 dark:bg-gray-900 focus:outline-none focus:ring-1 focus:z-2', {
                    [className]: className.length > 0,
                    '!pr-8': hasAction,
                }), onKeyDown: e => {
                    if (e.key === 'Enter' && hasAction) {
                        onAction();
                    }
                } }), hasAction ? (_jsx("div", { className: cx('!absolute inset-y-[1px] right-[1px] rounded-bl-none rounded-tl-none rounded-md w-8 z-4'), children: actionButton != null ? (actionButton) : (_jsx(Button, { variant: "secondary", onClick: onAction, className: cx('h-full !px-2'), children: actionIcon })) })) : null] }));
};
export default Input;
